import ProjectDetailsTabsContent from "pages/project/details/ProjectDetailsTabsContent";
import { useProjectDetailsContext } from "pages/project/context/ProjectDetailsContext";

export default function ProjectDetailsTabsPanel() {
  const { tabs, activeTabId, setActiveTabId } = useProjectDetailsContext();

  return (
    <section className="rounded-xl border border-slate-200 bg-white shadow-card">
      <div className="border-b border-slate-200 px-3 py-2">
        <div className="flex flex-wrap gap-2">
          {tabs.map((tab) => {
            const isActive = tab.id === activeTabId;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTabId(tab.id)}
                className={`rounded-lg px-2 py-2 text-sm font-semibold transition ${
                  isActive
                    ? "bg-brand-900 text-white"
                    : "border border-slate-200 bg-white text-text-700 hover:bg-slate-50"
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      <ProjectDetailsTabsContent />
    </section>
  );
}
